/* eslint-disable @typescript-eslint/no-unused-vars */

/* eslint-disable prefer-rest-params */

export function urljoin(...params: unknown[]): string {
    let input = arguments;

    if (typeof arguments[0] === 'object') {
        // new syntax with array and options
        input = arguments[0];
    }

    const joined = [].slice.call(input, 0).join('/');

    return normalize(joined);
}

export function encodeParams(param: unknown): string | null {
    if (!param) {
        return null;
    }

    const encoded = encodeObject(param);

    if (!encoded) {
        return null;
    }

    return encoded.filter((part) => part).join('&');
}

function normalize(str: string): string {
    // make sure protocol is followed by two slashes
    str = str.replace(/:\//g, '://');

    // remove consecutive slashes
    str = str.replace(/([^:\s])\/+/g, '$1/');

    // remove trailing slash before parameters or hash
    str = str.replace(/\/(\?|&|#[^!])/g, '$1');

    // replace ? in parameters with &
    str = str.replace(/(\?.+)\?/g, '$1&');

    return str;
}

function encodeObject(param: unknown): Array<string> | null {
    if (Array.isArray(param)) {
        if (param.length === 0) {
            return null;
        }

        return param
            .map((current, index) => {
                const result = encodeObject(current);

                return Array.isArray(result) ? result.map((x) => `[${index}].${x}`) : [`[${index}]=${current}`];
            })
            .reduce((current, next) => current.concat(next));
    }

    if (param instanceof Object) {
        const keys = Object.keys(param);

        const propertiesToEncode = (key: string): boolean => {
            const value = param[key as keyof typeof param] as unknown;
            // eslint-disable-next-line eqeqeq
            return value !== null && value !== undefined && (Array.isArray(value) ? value.length !== 0 : value !== '');
        };

        const encodeProperty = (key: string): string[] => {
            const value = param[key as keyof typeof param] as unknown;
            const encoded = encodeObject(value);
            const join = Array.isArray(value) ? '' : '.';

            if (!encoded) {
                return [`${key}=${encodeURIComponent(value as string | number | boolean)}`];
            }

            return encoded.map((pair) => `${key}${join}${pair}`);
        };

        const encodedValues = keys
            .filter(propertiesToEncode)
            .map(encodeProperty)
            .reduce((flatArray, next) => flatArray.concat(next), []);

        if (encodedValues.length) {
            return encodedValues;
        }
    }

    return null;
}
